Set.prototype.filter = function (criteria) {
  function* iterate(items) {
    for (const item of items) if (criteria(item)) yield item;
  }
  return [ ...iterate(this) ]
}